import type { List } from '../@types/microcredits';

export function formatForSEAOffersLimitExperiment(offers: List.IMicrocredit[], amount: number | undefined) {
  const _offers = offers.slice(0, 16);

  if (!amount) return _offers;

  return _offers.filter((offer) => offer.amountRange.to >= amount && offer.amountRange.from <= amount);
}
